// JsFromRoutes CacheKey 363d8a95fb5da35d6bcb3f54a405eafb
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/locations/search'),
  popular: /* #__PURE__ */ definePathHelper('get', '/locations/popular'),
  batch: /* #__PURE__ */ definePathHelper('get', '/locations/batch'),
}
